import React from 'react';
import { map, find, size, isUndefined } from 'lodash';
import { Row, Col, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
// import ClickableScreenReader from '../../ScreenReader/ClickableScreenReader';
import UnClickableScreenReader from '../../ScreenReader/UnClickableScreenReader';

import './styles.css';

class MatchingQuestions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      totalMatched: 0,
      isLeftSelected: false,
      A: { isSelected: false, isMatched: false },
      D: { isSelected: false, isMatched: false },
      E: { isSelected: false, isMatched: false },
      F: { isSelected: false, isMatched: false },
      G: { isSelected: false, isMatched: false },
      H: { isSelected: false, isMatched: false },
      I: { isSelected: false, isMatched: false },
      J: { isSelected: false, isMatched: false },
      K: { isSelected: false, isMatched: false },
      L: { isSelected: false, isMatched: false }
    };
    this.onSelectLeft = this.onSelectLeft.bind(this);
    this.onSelectRight = this.onSelectRight.bind(this);
  }

  onSelectLeft(event) {
    const value = event.target.value || event.target.getAttribute('value');
    this.setState({
      [value]: {
        isSelected: !this.state[value].isSelected,
        isMatched: this.state[value].isMatched
      },
      isLeftSelected: !this.state.isLeftSelected
    });
  }
  onSelectRight(event) {
    const { options } = this.props;
    const value = event.target.value || event.target.getAttribute('value');
    const valueMatched = find(options, { prefix: value }).matching;
    if (this.state[valueMatched].isSelected === true) {
      this.setState({
        [value]: { isSelected: true, isMatched: true },
        [valueMatched]: {
          isMatched: true,
          isSelected: this.state[valueMatched].isSelected
        },
        totalMatched: this.state.totalMatched + 1,
        isLeftSelected: false
      });
    }
  }

  render() {
    const { questions, options, nextRoute, previousRoute } = this.props;
    const renderOptions = map(options, (item, index) => {
      if (index % 2 === 0) {
        return (
          <div key={index}>
            <li className="col-xs-5" role="button">
              <input
                type="radio"
                id={item.prefix}
                value={item.prefix}
                onClick={this.onSelectLeft}
                disabled={
                  this.state[item.prefix].isMatched ||
                  (this.state.isLeftSelected === true &&
                    !this.state[item.prefix].isSelected)
                }
              />
              <label
                className={this.state[item.prefix].isSelected ? 'selected' : ''}
                htmlFor={item.prefix}
                id={item.prefix}
              >
                {/*<ClickableScreenReader
                  text={item.optionText}
                  value={item.prefix}
                  event={true}
                  handleEvent={this.onSelectLeft}
                  disabled={
                    this.state[item.prefix].isMatched ||
                    (this.state.isLeftSelected === true &&
                      !this.state[item.prefix].isSelected)
                  }
                />*/}
                <UnClickableScreenReader text={item.optionText} />
                <p className="text-center">{item.optionText}</p>
              </label>
            </li>
            <li className="col-xs-2" />
            <div
              style={
                this.state[item.prefix].isMatched
                  ? { visibility: 'visible' }
                  : { visibility: 'hidden' }
              }
              className={`match-line line-${item.prefix}`}
            />
          </div>
        );
      }

      return (
        <div key={index}>
          <li className="col-xs-5" role="button">
            <input
              type="radio"
              id={item.prefix}
              value={item.prefix}
              onClick={this.onSelectRight}
              disabled={this.state[item.prefix].isMatched}
            />
            <label
              className={this.state[item.prefix].isSelected ? 'selected' : ''}
              id={item.prefix}
              htmlFor={item.prefix}
            >
              {/*<ClickableScreenReader
                text={item.optionText}
                value={item.prefix}
                event={true}
                handleEvent={this.onSelectRight}
                disabled={this.state[item.prefix].isMatched}
              />*/}
              <UnClickableScreenReader text={item.optionText} />
              <p className="text-center">{item.optionText}</p>
            </label>
          </li>
        </div>
      );
    });

    const renderResult =
      size(options) === this.state.totalMatched * 2 ? (
        <Row className="quiz-answer">
          <Col xs={10} xsOffset={1} md={8} mdOffset={2}>
            <div style={{ display: 'flex' }} className="text-center">
              <div aria-label="correct" className="correct txt-green" />
              <div
                aria-label={questions.feedback.correct}
                style={{ position: 'relative', padding: '0 40px' }}
              >
                <UnClickableScreenReader text={questions.feedback.correct} />
                {questions.feedback.correct}
              </div>
            </div>
          </Col>
        </Row>
      ) : null;

    return (
      <div>
        <section>
          <div className="container matching-qestuion">
            <Row className="text-center">
              <Col xs={12} md={6} mdOffset={3}>
                <h2 className="txt-blue no-bold">{questions.title}</h2>

                <p>{questions.text}</p>
              </Col>
            </Row>
            <ul className="row">{renderOptions}</ul>
            {renderResult}
          </div>
        </section>
        <section>
          <div className="container text-center">
            <Row>
              <Col xs={12}>
                <Button
                  className="btn btn-blue previous"
                  onClick={previousRoute}
                >
                  Previous
                </Button>
                {!isUndefined(nextRoute) &&
                  this.state.totalMatched === 4 && (
                    <LinkContainer to={nextRoute} className="btn btn-blue next">
                      <Button>Next</Button>
                    </LinkContainer>
                  )}
              </Col>
            </Row>
          </div>
        </section>
      </div>
    );
  }
}

export default MatchingQuestions;



// WEBPACK FOOTER //
// ./src/components/Questions/MatchingQuestions/index.jsx